<template>
  <li class="dropdown dropdown-notification nav-item">
    <a href="#" data-toggle="dropdown" class="nav-link nav-link-label">
      <i class="ficon icon-bell4"></i>
      <span
        v-if="newNotificationsCount"
        class="tag tag-pill tag-default tag-danger tag-default tag-up"
      >{{newNotificationsCount}}</span>
    </a>
    <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right">
      <li class="dropdown-menu-header">
        <h6 class="dropdown-header m-0">
          <span class="grey darken-2">Уведомления</span>
          <span
            v-if="newNotificationsCount"
            class="notification-tag tag tag-default tag-danger float-xs-right m-0"
          >{{newNotificationsCount}} новых</span>
        </h6>
      </li>
      <li class="list-group scrollable-container">
        <div v-if="!getNotifications.length" style="margin:20px;">
          <p class="notification-text font-small-3 text-muted">Нет уведомлений</p>
        </div>
        <notification
          v-for="notification in getNotifications"
          :key="notification.id"
          :type="notification.type"
          :message="message(notification)"
          :datetime="notification.cdate+'+0000'"
          :seen="!!notification.seen_date"
          @click.native="checkNotification(notification.id)"
        />
      </li>
      <li class="dropdown-menu-footer">
        <a href="javascript:void(0)" class="dropdown-item text-muted text-xs-center">Все уведомления</a>
      </li>
    </ul>
  </li>
</template>

<script>
import notification from "@/components/notification.vue";
import { mapGetters } from "vuex";
import {
  NOTIFICATIONS_REQUEST,
  NOTIFICATIONS_SEEN_REQUEST,
} from "@/store/actions/notifications";

export default {
  name: "NotificationsDropdown",
  components: {
    notification,
  },
  computed: {
    ...mapGetters([
      "getNotifications",
      "isNotificationsLoading",
      "isNotificationsFailed",
      "isNotificationsSeenLoading",
      "isNotificationsSeenFailed",
      "notificationsOnceLoaded",
      "newNotificationsCount",
    ]),
  },
  methods: {
    checkNotification(notification_id) {
      this.$store
        .dispatch(NOTIFICATIONS_SEEN_REQUEST, { notification_id })
        .then(() => {});
    },
    message(notification) {
      let b = notification.body;
      if (b.message) return b.message;
      switch (notification.type) {
        case "bill":
          return `По заявке №${b.request_id} поступил новый счёт №${b.number}`;
        case "waybill":
          return `По заявке №${b.request_id} поступила новая накладная №${b.number}`;
        case "invoice":
          return `По заявке №${b.request_id} поступил новый счёт-фактура №${b.number}`;
        default:
          return "Сообщение";
      }
    },
  },
  created() {
    if (!this.notificationsOnceLoaded)
      this.$store.dispatch(NOTIFICATIONS_REQUEST);
  },
};
</script>